export default __webpack_public_path__ + "static/media/closet5-after3-768w.4f3331a2.png";